import { useSelector } from 'react-redux'
import classes from './Sidebar.module.css'
import SidebarHeader from './SidebarHeader/SidebarHeader'
import SidebarFooter from './SidebarFooter/SidebarFooter'
import SessionList from './SessionList/SessionList'

function Sidebar() {
  const sidebarState = useSelector(state => state.sidebar)
  const isMobile = useSelector(state => state.layout).isMobile

  const header = <SidebarHeader/>


  let Sidebar = (
    <div className={classes.Sidebar}>
      <div className={classes.Header}>
        {header}
      </div>
      <div className={classes.SessionList}><SessionList/></div>
      <div className={classes.Footer}><SidebarFooter/></div>
    </div>
  )
  if (!sidebarState.isOpen) {
    Sidebar = (
      <div className={classes.ClosedSidebar}>
        <div className={classes.Header}>
          {header}
        </div>
        <div className={classes.Footer}>
          <SidebarFooter collapsed />
        </div>
      </div>
    )
    if (isMobile) {
      Sidebar = null
    }
  }


  return (
    Sidebar
  );
}

export default Sidebar;
